import { renderIsomorphicComponent, renderBreakingNews, renderComponent } from "@quintype/framework/client/start";
import { pickComponent } from "../isomorphic/pick-component";
import BreakingNews from "../isomorphic/components/rows/breaking-news";
import Footer from "../../app/isomorphic/components/rows/footer";
import Header from "../../app/isomorphic/components/rows/header";

export function preRenderApplication(store) {
  renderComponent(Header, "header", store);
  renderComponent(Footer, "footer", store);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  global.qtConfig = store && store.getState().qt.config;
  renderIsomorphicComponent("container", store, pickComponent, {
    hydrate: !global.qtLoadedFromShell
  });
  renderBreakingNews("breaking-news-container", store, BreakingNews);
}
